"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWidth = exports.calculateHeight = void 0;
var ParamExtractor_1 = require("../ParamExtractor/ParamExtractor");
exports.calculateHeight = function (pageSettings, cmsElementContext) {
    return pageSettings
        ? ParamExtractor_1.extractParam(pageSettings, cmsElementContext, 'bannerHeight') + "px"
        : '0';
};
exports.calculateWidth = function (pageSettings, cmsElementContext) {
    return pageSettings
        ? ParamExtractor_1.extractParam(pageSettings, cmsElementContext, 'bannerWidth') + "px"
        : '0';
};
//# sourceMappingURL=DimensionCalculator.js.map